var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unidentified-object-icon",style:(_vm.cssVars)},[(_vm.isSafe)?_c('unidentified-object-safe'):(_vm.isCaution)?_c('unidentified-object-caution'):_c('unidentified-object-danger')],1)}
var staticRenderFns = []

export { render, staticRenderFns }